export class HaloclineException extends Error {
    protected constructor(message?: string, proto = HaloclineException) {
        super(message)

        this.name = proto.name ?? 'HaloclineException'
        try {
            Object.setPrototypeOf(this, proto.prototype)
        } catch {}
    }
}
